var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4C14.1604 4 13.75 4.44772 13.75 5C13.75 5.55228 14.1604 6 14.6667 6C17.7042 6 20.1667 8.68629 20.1667 12C20.1667 15.3137 17.7042 18 14.6667 18C14.1604 18 13.75 18.4477 13.75 19C13.75 19.5523 14.1604 20 14.6667 20C18.7168 20 22 16.4183 22 12C22 7.58172 18.7168 4 14.6667 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8C14.1604 8 13.75 8.44771 13.75 9C13.75 9.55228 14.1604 10 14.6667 10C15.6792 10 16.5 10.8954 16.5 12C16.5 13.1046 15.6792 14 14.6667 14C14.1604 14 13.75 14.4477 13.75 15C13.75 15.5523 14.1604 16 14.6667 16C16.6917 16 18.3333 14.2091 18.3333 12C18.3333 9.79086 16.6917 8 14.6667 8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34273 10.0002H2.75C2.24374 10.0002 1.83333 10.4479 1.83333 11.0002V13.0002C1.83333 13.5525 2.24374 14.0002 2.75 14.0002H5.34273L8.51848 17.4647C9.09595 18.0946 10.0833 17.6485 10.0833 16.7575V7.24283C10.0833 6.35192 9.09595 5.90576 8.51849 6.53572L5.34273 10.0002ZM4.58333 16.0002L7.22212 18.8789C8.95452 20.7688 11.9167 19.4303 11.9167 16.7575V7.24283C11.9167 4.57012 8.95453 3.23162 7.22212 5.12151L4.58333 8.00019H2.75C1.23122 8.00019 0 9.34334 0 11.0002V13.0002C0 14.657 1.23122 16.0002 2.75 16.0002H4.58333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeIcon);
export default __webpack_public_path__ + "static/media/VolumeIcon.b7abbff6.svg";
export { ForwardRef as ReactComponent };